import React, { useEffect, useRef } from "react";
import { gettext, View } from "../utils/legacy";

export default function AgGridTable(props: any) {
  const ref = useRef(null);
  const { className, ...p } = props;
  useEffect(() => {
    if (!ref?.current) return;
    new View.AgGridView({ el: ref.current, ...p });
  }, [p, ref]);
  return (
    <div className={className} ref={ref}>
      {gettext("Loading")}...
    </div>
  );
}
